<template>
  <ValidationProvider
    v-slot="{ errors, validate, ariaInput, ariaMsg }"
    name="FCP Start Date"
    :rules="required ? 'required' : ''"
  >
    <div class="position-relative">
      <label for="bdx-edit-form-fcp-start-date">
        FCP Start Date
        <span class="text-danger" v-if="required">*</span>
      </label>
      <DatePicker
        :value="modelValue"
        @input="handleInput"
        :format="DATE_FORMAT"
        value-type="format"
        v-bind="$attrs" 
        :input-attr="{
          id: 'bdx-edit-form-fcp-start-date',
          ...ariaInput,
          'data-vv-name': 'FCP Start Date',
          'data-vv-validate-on': 'blur|change',
          placeholder: useKeepAsIsOption ? 'Keep as is' : '',
        }"
        :class="{ 'is-invalid': errors.length > 0 }"
      />

      <div v-if="!!errors.length" class="invalid-feedback d-block">
        {{ errors[0] }}
      </div>
    </div>
  </ValidationProvider>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { ValidationProvider } from 'vee-validate'
import DatePicker from 'vue2-datepicker'

import { DATE_FORMAT } from '@constants'

export default defineComponent({
  name: 'BDXEditFormFCPStartDate',
  components: {
    ValidationProvider,
    DatePicker
  },
  props: {
    value: String,
    required: {
      type: Boolean,
      default: false,
    },
    useKeepAsIsOption: Boolean,
  },
  emits: ['input'],
  setup(props, { emit }) {
    const modelValue = computed({
      get: () => props.value || '',
      set: (newValue) => emit('input', newValue)
    })

    const handleInput = (value) => {
      emit('input', value)
    }

    return {
      DATE_FORMAT,
      modelValue,
      handleInput
    }
  }
})
</script>

<style scoped>
.mx-datepicker {
  width: 100%;
}

.mx-datepicker >>> .mx-input {
  border-radius: 4px;
  border-color: #e9ecef;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
}

.mx-datepicker.is-invalid >>> .mx-input {
  border-color: #dc3545;
}

.mx-datepicker >>> .mx-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.mx-datepicker.is-invalid >>> .mx-input:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
}
</style>
